import React from "react";
import FullScreenLoadingAnimation from "components/FullScreenLoadingAnimation";

const Callback = () => {
  return <FullScreenLoadingAnimation />;
};

export default Callback;
